<template>
<div>  
    <!-- 标题 -->
    <div class="navbar">
        <img width="50px" height="50px" src="../../../../static/assets/img/icon.png" />
        <div style="font-size:x-large;margin-left: 5%;width: 62%;">塔兮App</div>
    </div>
    <!-- 内容 -->
    <div v-if="success==false">
        <van-empty image="error" :description=msg />
    </div>
    <div v-else style="margin-left: 3%;">
        <el-row justify="start">
            <el-col :span="17">
                <div>
                <!-- 媒体内容类 -->
                    <!-- 图片类 -->
                    <div v-if="data.fileType==1">
                    <div>
                        <el-carousel height="480px" indicator-position="outside">
                            <el-carousel-item  v-for="(item,index) in data.contentMedias" :key=index class="indexItem">
                                <img :src=item.mediaUrl  style="height: 450px;display: flex;">
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    </div>
                    <!-- 视频类 -->
                    <div v-if="data.fileType==0">
                        <div v-if="data.lockFlag==0">
                            <video controls="controls" width="100%" height="480px" :poster=data.coverUrl style="background-color: black;margin: 10px;" autoplay="autoplay">
                                <source :src=data.contentMedias[0].mediaUrl type="video/mp4">
                            </video>
                        </div>
                        <div v-else>
                            <div>
                                <img :src=data.coverUrl width="100%" style="height: 450px;display: flex;">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 详情 -->
                <div style="padding: 20px 10px;">
                    <!-- 用户信息 -->
                    <div class="user"> 
                        <el-avatar :size="50" :src=user.headUrl />
                        <div style="margin-left:10px;width: 100%;">
                        <el-row justify="space-between">
                            <el-col :span="17"><div>{{user.nickname}}</div></el-col>
                            <el-col :span="7"><div style="color: #939393;text-align: right;font-size: 13px;">{{data.createTime}}</div></el-col>
                        </el-row>
                            <div class="txid">塔兮ID：{{user.username}}</div>
                        </div>
                    </div>
                    <!-- 内容描述 -->
                    <div style="margin-top:10px" class="van-multi-ellipsis--l2">
                        {{data.details}}
                    </div>

                <!-- 悬浮按钮 -->
                <el-button type="primary" @click="showApp" style="width: 60%;height: 70px;border-radius: 35px;font-size: larger;">打开APP，发现更多精彩</el-button>
                </div>
            </el-col>
            <el-col :span="7">
                <div style="margin-left: 5%;margin-right: 3%;display:flex;flex-direction: column;">
                    <p style="font-size: larger;">相关推荐</p>
                    <pc-recommend-list :recommends="recommends"></pc-recommend-list>
                </div>

            </el-col>
        </el-row>
    </div>
</div>
     
    
</template>

<script>
import PcRecommendList from '../../content/PcRecommendList.vue'

export default {
    name:'PCShare',
    components:{PcRecommendList},
    props:{
        data:{
            type:Object,
            default(){
                return {}
            }
        },
        user:{
            type:Object,
            default(){
                return {}
            }
        },
        video:{
            type:String,
            default(){
                return ''
            }
        },
        msg:{
            type:String,
            default(){
                return ''
            }
        },
        success:{
            type:Boolean,
            default(){
                return false
            }
        },
        recommends:{
            type:[],
            default(){
                return []
            }
        }
    },
    methods:{

        showApp(){
             this.$router.push({
                path: "/"
            });
        },
    }
}
</script>

<style scoped> 
.navbar{
    display: flex;
    align-items:center;
    justify-content: start;
    height:2px;
}

.txid{
    color: #939393;
    text-align:left;
}

.user{
    display: flex;
    justify-content: flex-start;
}
               
.indexItem {
    display: flex;
    align-items: center;
    justify-content: center;
}

</style>


// WEBPACK FOOTER //
// src/components/common/share/PcShare.vue